var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Loading',{attrs:{"isLoading":_vm.caseLoading}},[_c('v-layout',{staticClass:"homepage-card-container",attrs:{"row":"","wrap":"","fluid":"","id":"case-history"}},_vm._l((_vm.items),function(c,caseIndex){return _c('CaseCard',{key:caseIndex,attrs:{"case-data":c}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }